export default __webpack_public_path__ + "static/media/coll-item-5.3ab14c0f.jpg";